import ContainerMobile from 'components/container-mobile';
import PrivateRoute from 'components/private-route';
import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const BookingTherapist = lazy(() => import('./pages/therapist/booking-therapist'));
const HomeTherapist = lazy(() => import('./pages/therapist/home-therapist'));
const WalletTherapist = lazy(() => import('./pages/therapist/wallet-therapist'));
const ProfileTherapist = lazy(() => import('./pages/therapist/profile-therapist'));
const ProfileDetailTherapist = lazy(() => import('./pages/therapist/profile-therapist/profile-detail-therapist'));
const ProfileLocationTherapist = lazy(() => import('./pages/therapist/profile-therapist/profile-location-therapist'));
const ProfileLocationTherapistMap = lazy(
    () => import('./pages/therapist/profile-therapist/profile-location-therapist/ProfileLocationTherapistPicker')
);
const ProfileAccountSetting = lazy(() => import('./pages/therapist/profile-therapist/profile-account-setting'));
const ChangePassword = lazy(() => import('./pages/therapist/profile-therapist/profile-account-setting/change-password'));
const BookingDetail = lazy(() => import('./pages/therapist/booking-detail-therapist'));
const RequestPayout = lazy(() => import('./pages/therapist/wallet-therapist/wallet-request-payout'));
const PayoutDetails = lazy(() => import('./pages/therapist/wallet-therapist/wallet-payout-details'));
const TransactionHistory = lazy(() => import('./pages/therapist/wallet-therapist/wallet-transaction-history'));
const Notification = lazy(() => import('./pages/therapist/notification'));
const Rating = lazy(() => import('./pages/therapist/rating-therapist'));
const PlatformRegulations = lazy(() => import('./pages/therapist/profile-therapist/profile-platform-regulations'));

function RoutingTherapist() {
    return (
        <Routes>
            <Route path="/therapist" element={<ContainerMobile />}>
                <Route path="home" element={<PrivateRoute auth="masseuse" element={<HomeTherapist />} />} />
                <Route path="my-booking/*" element={<PrivateRoute auth="masseuse" element={<BookingTherapist />} />} />
                <Route path="my-booking/detail/:bookingId" element={<PrivateRoute auth="masseuse" element={<BookingDetail />} />} />
                <Route path="wallet" element={<PrivateRoute auth="masseuse" element={<WalletTherapist />} />} />
                <Route path="my-profile" element={<PrivateRoute element={<ProfileTherapist />} auth="masseuse" />} />
                <Route path="location-setting" element={<PrivateRoute element={<ProfileLocationTherapist />} auth="masseuse" />} />
                <Route path="profile-detail/*" element={<PrivateRoute element={<ProfileDetailTherapist />} auth="masseuse" />} />
                <Route path="location-setting/map" element={<PrivateRoute element={<ProfileLocationTherapistMap />} auth="masseuse" />} />
                <Route path="account-setting" element={<PrivateRoute element={<ProfileAccountSetting />} auth="masseuse" />} />
                <Route path="change-password" element={<PrivateRoute element={<ChangePassword />} auth="masseuse" />} />
                <Route path="request-payout" element={<PrivateRoute auth="masseuse" element={<RequestPayout />} />} />
                <Route path="payout-details/:id" element={<PrivateRoute auth="masseuse" element={<PayoutDetails type="requested" />} />} />
                <Route path="payout-completed-details/:id" element={<PrivateRoute auth="masseuse" element={<PayoutDetails type="complete" />} />} />
                <Route path="payment-details/:id" element={<PrivateRoute auth="masseuse" element={<PayoutDetails type="settlement" />} />} />
                <Route path="transaction-history" element={<PrivateRoute auth="masseuse" element={<TransactionHistory />} />} />
                <Route path="notifications" element={<PrivateRoute auth="masseuse" element={<Notification />} />} />
                <Route path="my-rating" element={<PrivateRoute auth="masseuse" element={<Rating />} />} />
                <Route path="platform-regulations" element={<PrivateRoute auth="masseuse" element={<PlatformRegulations />} />} />
            </Route>
        </Routes>
    );
}

export default RoutingTherapist;
